export const colors = {
  primary: {
    0: "#279d2e",
    "0-transp": "rgba(39, 157, 46, 0.9)",
  },
  secondary: {
    0: "#EBEBEB",
    "0-transp": "#EBEBEB00",
    1: "#3c3c3b",
    2: "#f2f2f2",
  },
  tertiary: {
    0: "#25b4bd",
    gradient: "linear-gradient(-45deg, #279D2EFF, #25B4BDFF)",
  },
  white: "#fff",
  black: "#000",
  red: "#E30012",
  skeleton: {
    primary: "#d8d8d8",
    secondary: "#c6c6c6",
    highlight: "#fdfdfd",
  },
  shadow: {
    gray: "rgba(100, 100, 100, 0.5)",
    black: "rgba(0,0,0,0)",
    blackTransp: "rgba(0,0,0,0.6)",
  },
  placeholder: "#646464",
};
